// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import ContactCard from '/react4xp/components/ContactCard'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

export interface ListContactsProps {
    title?: string
    intro?: string
    contactCard: Array<{
        image?: {
            src: string
            alt?: string
        }
        name?: string
        position?: string
        email?: {
            isVisible: boolean
            revealText: string
            email: string
        }
    }>
}

export default function ListContacts({
    title,
    intro,
    contactCard
}: ListContactsProps) {
    return (
        <Section
            textColor='text-dark'
            className='list-contacts'
        >
            <div className='grid-container'>
                <div className='grid-row'>

                    <div className='c-md-5 c-xl-4 list-contacts__left'>

                        {isNonWhitespaceString(title) && (
                            <h2 className='title-md list-contacts__title'>
                                {title}
                            </h2>
                        )}

                        {isNonWhitespaceString(intro) && (
                            <div
                                dangerouslySetInnerHTML={{ __html: intro }}
                                suppressHydrationWarning
                                className='list-contacts__intro text-md'
                            />
                        )}

                    </div>

                    <div className='c-md-6 start-md-7 list-contacts__right'>

                        {contactCard && contactCard.length > 0 && (
                            <div className={clsx(
                                'list-contacts__cards',
                                //!title && 'list-contacts__cards--no-title'
                            )}>
                                {contactCard.map((item, i) => (
                                    <ContactCard
                                        key={i}
                                        image={item.image}
                                        name={item.name}
                                        position={item.position}
                                        email={item.email}
                                    />
                                ))}
                            </div>
                        )}

                    </div>

                </div>
                
            </div>
        </Section>
    )
}

